const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const withContainerDims = require("../hoc/withContainerDims");
const AssetsUtil = require("../util/AssetsUtil");
const ImageLoader = require("../util/ImageLoader");

const styles = require("./styles/Tooltip.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withContainerDims(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "Tooltip",

		propTypes: {
			className: PT.string,
			tooltipText: PT.string,
			tooltipStyle: PT.object,
			size: PT.oneOf(["small", "medium", "medium-wrap", "large"]),
			// Boolean that will lengthen tooltip if it would overflow, only applies
			// to "small" and "medium" as large/medium-wrap is shaped to wrap text. It approximates
			// stretching by number of characters, but should be tested when used as it
			// wouldn't, for example, correctly make "WWWWWWWWWWWWWWW" fit.
			stretchWidth: PT.bool,
			//location of tooltip relative to element:
			direction: PT.oneOf([
				"top-left",
				"top-right",
				"bottom-left",
				"bottom-right",
			]),
			hidden: PT.bool,
			// Injected by HOCs
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		getDefaultProps: function() {
			return {
				size: "small",
				stretchWidth: false,
			};
		},

		getInitialState: function() {
			return {
				isHovering: false,
				position: null,
			};
		},

		componentDidMount: function() {
			let size = this.props.size;
			if (size === "medium-wrap") size = "large";
			ImageLoader.preload(AssetsUtil.getTooltip(size));
		},

		componentWillUnmount: function() {
			if (this.hoverTimeout) {
				clearTimeout(this.hoverTimeout);
			}
		},

		onClick: function(evt) {
			this.initiateHoverTimeout(false);
		},

		startHover: function(evt) {
			evt.preventDefault();
			this.setState({position: {x: evt.pageX, y: evt.pageY}});
			this.initiateHoverTimeout(true);
		},

		onMouseMove: function(evt) {
			this.setState({position: {x: evt.pageX, y: evt.pageY}});
		},

		endHover: function(evt) {
			evt.preventDefault();
			this.initiateHoverTimeout(false);
		},

		initiateHoverTimeout: function(pendingHover) {
			if (this.hoverTimeout) {
				clearTimeout(this.hoverTimeout);
			}

			this.hoverTimeout = setTimeout(
				() => {
					this.setState({
						isHovering: pendingHover,
						position: pendingHover ? this.state.position : null,
					});
				},
				pendingHover ? 450 : 1
			);
		},

		render: function() {
			let tooltip = null;
			const {
				width,
				height,
				windowWidth,
				windowHeight,
			} = this.props.containerDims;
			const {
				size,
				stretchWidth,
				tooltipText,
				tooltipStyle,
				className,
				children,
			} = this.props;
			if (tooltipText && this.state.isHovering && this.state.position) {
				let direction = this.props.direction;
				const style = tooltipStyle || {};
				let w = style.width;
				let h = style.height;
				if (!w || !h) {
					if (size === "small") {
						w = width / 9;
						h = width / 22;
					} else if (size === "medium") {
						w = width / 6;
						h = width / 20;
					} else if (size === "medium-wrap") {
						w = width / 4.5;
						h = width / 12;
					} else if (size === "large") {
						w = width / 3.5;
						h = width / 8;
					}
					if (stretchWidth) {
						const maxCharMap = {
							small: 10,
							medium: 15,
						};
						if (maxCharMap[size] && tooltipText.length > maxCharMap[size]) {
							w += (width / 125) * (tooltipText.length - maxCharMap[size]);
						}
					}
				}
				const p = this.state.position;
				const minX = (windowWidth - width) / 2;
				const maxX = minX + width;
				const minY = (windowHeight - height) / 2;
				const maxY = minY + height;
				if (p && !direction) {
					if (p.y - h > minY && p.x - w > minX) {
						direction = "top-left";
					} else if (p.y - h > minY && p.x + w < maxX) {
						direction = "top-right";
					} else if (p.y + h < maxY && p.x - w > minX) {
						direction = "bottom-left";
					} else if (p.y + h < maxY && p.x + w < maxX) {
						direction = "bottom-right";
					}
				}
				// direction = "bottom-right";
				let left, top, scale;
				if (direction === "top-left") {
					left = p.x - minX - w;
					top = p.y - minY - h;
					scale = "";
				} else if (direction === "top-right") {
					left = p.x - minX;
					top = p.y - minY - h;
					scale = "scaleX(-1)";
				} else if (direction === "bottom-left") {
					left = p.x - minX - w;
					top = p.y - minY;
					scale = "scaleY(-1)";
				} else if (direction === "bottom-right") {
					left = p.x - minX;
					top = p.y - minY;
					scale = "scale(-1,-1)";
				}

				const divStyle = _.extend(
					{},
					{
						left,
						top,
						width: w,
						height: h,
						transform: scale,
					},
					tooltipStyle
				);

				const textStyle = {
					zIndex: tooltipStyle && tooltipStyle.zIndex,
				};

				const innerText = {
					transform: scale,
				};

				let assetSrc = AssetsUtil.getTooltip(size);
				if (size === "medium-wrap") assetSrc = AssetsUtil.getTooltip("large");

				tooltip = (
					<Portal container={PORTAL_CONTAINERS.TOOLTIP}>
						<div className={styles.outer} style={divStyle}>
							<img className={styles.bg} src={assetSrc} />
							<div style={textStyle} className={styles[size]}>
								<div style={innerText} className={styles.content}>
									{tooltipText}
								</div>
							</div>
						</div>
					</Portal>
				);
			}

			let tooltipClass = className;
			if (this.props.hidden) {
				tooltipClass += " " + styles.hidden;
			}

			return (
				<div
					onMouseEnter={this.startHover}
					onMouseLeave={this.endHover}
					onMouseMove={this.onMouseMove}
					onClick={this.onClick}
					className={tooltipClass}
				>
					{children}
					{tooltip}
				</div>
			);
		},
	})
);
